import React, { useState, useContext } from 'react'
import { Tabs } from 'antd'
import ProductTab from './productTabs/productTab'
import PresentationTab from './presentationTabs/presentationTab'
import DiscountTab from './discountTabs/discountTab'
import SkuTab from './skuTabs/skuTab'
import ComboTab from './comboTabs/comboTab'
import DownloadTab from './downloadTabs/downloadTab'
import UploadTab from './uploadTabs/uploadTab'

import { Context } from '../../../context'
import { CambioPrecioTabTable } from './CambiosprecioTabs/CambioPrecioTabTable'

const { TabPane } = Tabs

function ProductsTabsIndex() {
  const [key, setKey] = useState('1')

  const [{ auth }] = useContext(Context)

  const onChangeTab = key => {
    setKey(key)
  } 

  return (
    <>
      <Tabs id={'tenderoShopTabs'} defaultActiveKey="1" onTabClick={onChangeTab}>
        <TabPane tab="Productos" key="1">
          <ProductTab keyTab={key} />
        </TabPane>
        <TabPane tab="Presentaciones" key="2">
          <PresentationTab keyTab={key} />
        </TabPane>
        {auth?.company?.allow_discount_levels === 1 && (
          <TabPane tab="Niveles de descuento" key="3">
            <DiscountTab keyTab={key} />
          </TabPane>
        )}
        <TabPane tab="SKUs" key="4">
          <SkuTab keyTab={key} />
        </TabPane>
        <TabPane tab="Combos" key="5">
          <ComboTab keyTab={key} />
        </TabPane>
        <TabPane tab="Descargar excel" key="6">
          <DownloadTab keyTab={key} />
        </TabPane>
        <TabPane tab="Subir excel" key="7">
          <UploadTab keyTab={key} />
        </TabPane>
        <TabPane tab="Cambios de precio" key="8">
          <CambioPrecioTabTable keyTab={key} />
        </TabPane>
      </Tabs>
    </>
  )
}

export default ProductsTabsIndex
